import $rdf from '@zazuko/env/web.js';
export class PatternBuilder {
    constructor() {
        this.results = $rdf.termMap();
    }
    // eslint-disable-next-line no-use-before-define
    build(expr, args) {
        const result = this.results.get(expr.term) || expr.build(args, this);
        this.results.set(expr.term, result);
        return result;
    }
}
export default class {
    build({ subject, rootPatterns, variable, object = variable() }, builder) {
        const patterns = this._buildPatterns({ subject, rootPatterns, variable, object }, builder);
        return {
            patterns: Array.isArray(patterns) ? patterns : [patterns],
            object,
            requiresFullContext: this.requiresFullContext,
        };
    }
}
